import axios from "axios";
import Config from "../utils/Config";

const BASE_URL = Config.apiUrl;

/**
 * Agent insurance purchases (policies sold by the logged-in agent).
 * GET https://api.tripsecuregh.com/api/agent/policy/get/all/purchased
 */
const PURCHASED_POLICIES_ENDPOINT = `${BASE_URL}/agent/policy/get/all/purchased`;

class AgentInsurancePurchases {
  getAuthHeaders() {
    const token = localStorage.getItem("trp_agt_tk") || "";
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  }

  /**
   * Fetch all insurance purchases (policies) sold by the logged-in agent.
   * Response shape will be adjusted in getItemDisplay when backend structure is confirmed.
   */
  async getAllInsurancePurchases() {
    try {
      const response = await axios.get(PURCHASED_POLICIES_ENDPOINT, this.getAuthHeaders());
      const inner = response.data?.data ?? response.data;
      // Support common response shapes; update when API response structure is provided
      const list = Array.isArray(inner?.data)
        ? inner.data
        : Array.isArray(inner?.purchases)
        ? inner.purchases
        : Array.isArray(inner?.policies)
        ? inner.policies
        : Array.isArray(inner)
        ? inner
        : [];
      const ok = inner?.status_code === 200 || response.status === 200;
      return {
        status: !!ok,
        data: inner,
        list,
        message: inner?.message ?? inner?.reason ?? "Insurance purchases fetched successfully",
      };
    } catch (error) {
      const code = error.response?.status;
      const message =
        error.response?.data?.message ??
        error.response?.data?.reason ??
        error?.message ??
        "Unable to load insurance purchases.";
      return {
        status: false,
        data: null,
        list: [],
        message,
      };
    }
  }
}

const agentInsurancePurchasesService = new AgentInsurancePurchases();
export default agentInsurancePurchasesService;
